export class WidgetConfig {
  title: string;
  api: string;
  id: number;
  widgetType: string;
  config?: Object;
  width?: number;
  permissions?: string;
}
